import BaseCard from './BaseCard';
import WhiteCard from './WhiteCard';

export { WhiteCard };

export default BaseCard;
